<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title>
        <v-toolbar>
          <!-- <v-icon color="brown">how_to_vote</v-icon> -->
          <v-toolbar-title class="font-weight-light">
            <v-row>
              <v-col>
                <div>&nbsp; Confirmación de Cobranza</div>
              </v-col>
            </v-row>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="hideActiveTask"
            ><v-icon>close</v-icon></v-btn
          >
        </v-toolbar>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col>
            <v-card>
              <v-card-text>
                <v-row class="caption" no-gutters>
                  <v-col cols="9" class="font-weight-bold">Detalle</v-col>
                  <v-col cols="3" class="text-right font-weight-bold"
                    >Importe</v-col
                  >
                  <!-- <v-col cols="1" class="text-right font-weight-bold"></v-col> -->
                </v-row>
                <template v-for="(item, index) in detalleCobranza">
                  <v-row class="caption" no-gutters :key="index">
                    <v-col cols="9">
                      <span
                        v-if="
                          item.tipo == 'Credito' &&
                          !item.item.numero.includes('Nota')
                        "
                        class="caption"
                        >- Cta. Nº {{ item.item.cuota }}, del Cred. Nº
                        <span class="font-italic font-weight-medium">
                          {{ item.numero }}
                        </span></span
                      >
                      <span
                        v-if="
                          item.tipo == 'Credito' &&
                          item.item.numero.includes('Nota')
                        "
                        class="caption"
                        >- ND Cta. Nº {{ item.item.cuota }}, del Cred. Nº
                        <span class="font-italic font-weight-medium">
                          {{ item.numero }}
                        </span></span
                      >
                      <span v-if="item.tipo == 'Acuerdo'" class="caption"
                        >- Cta. Acuerdo {{ item.item.cuota }}</span
                      >
                      <!-- <span v-if="item.tipo == 'Credito'" class="caption">- Cta. Nº {{item.item.cuota}}, Vto. {{item.item.vencimiento | dateParse() | dateFormat('MM/YY')}} del Cred. Nº <span class="font-italic font-weight-medium"> {{item.numero}} </span></span> -->
                      <span v-else class="caption"
                        >- {{ item.tipo }} Nº {{ item.numero }}</span
                      >
                    </v-col>
                    <v-col cols="3"
                      ><div class="text-right">
                        {{ item.total | currency }}
                      </div></v-col
                    >
                    <!-- <v-col cols="1"><div class="text-right" ><v-icon color="red" small @click="quitarConceptoPago(item)">clear</v-icon></div></v-col> -->
                  </v-row>
                </template>
                <v-divider></v-divider>
                <v-row class="caption" no-gutters>
                  <v-col cols="9" class="text-center font-weight-bold"
                    >TOTAL</v-col
                  >
                  <v-col cols="3" class="text-right font-weight-bold">{{
                    totalAPagar | currency
                  }}</v-col>
                  <!-- <v-col cols="1" class="text-right font-weight-bold"></v-col> -->
                </v-row>
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-row>
          <v-col>
            <v-card>
              <v-card-text>
                <v-row>
                  <v-col class="font-weight-bold">Forma de Pago</v-col>
                </v-row>
                <v-row class="caption" no-gutters>
                  <v-btn-toggle v-model="formaPago" mandatory>
                    <v-btn color="success" small text value="efectivo"
                      >Efectivo</v-btn
                    >
                    <v-btn
                      color="info"
                      small
                      text
                      value="transferencia"
                      v-if="
                        $store.state.parametrosGenerales
                          .cajaHabilitarCobroTransferencia
                      "
                      >Transferencia</v-btn
                    >
                    <v-btn
                      color="error"
                      small
                      text
                      value="cheque"
                      v-if="
                        $store.state.parametrosGenerales
                          .cajaHabilitarCobroCheque
                      "
                      >Cheque</v-btn
                    >
                    <v-btn
                      color="warning"
                      small
                      text
                      value="tarjeta"
                      v-if="
                        $store.state.parametrosGenerales
                          .cajaHabilitarCobroTarjeta
                      "
                      >Tarjeta</v-btn
                    >
                    <v-btn
                      color="indigo"
                      small
                      text
                      value="mercadoPago"
                      v-if="
                        $store.state.parametrosGenerales
                          .cajaHabilitarCobroMercadoPago
                      "
                      >Mercado Pago</v-btn
                    >
                    <v-btn
                      color="pink"
                      small
                      text
                      value="posnet"
                      v-if="
                        $store.state.parametrosGenerales
                          .cajaHabilitarCobroMercadoPago
                      "
                      >POSNET</v-btn
                    >
                    <v-btn
                      color="brown"
                      small
                      text
                      value="cbu"
                      v-if="
                        $store.state.parametrosGenerales
                          .cajaHabilitarCobroMercadoPago
                      "
                      >Débito CBU</v-btn
                    >
                  </v-btn-toggle>
                </v-row>
                <v-row v-if="formaPago == 'efectivo'">
                  <v-container fluid>
                    <v-row>
                      <v-col
                        cols="3"
                        v-if="
                          $store.state.parametrosGenerales
                            .cajaPermiteMultiMoneda && cajaMultiMoneda
                        "
                      >
                        <v-autocomplete
                          :items="listMonedas"
                          v-model="model.monedaId"
                          placeholder="Moneda"
                          item-text="simbolo"
                          item-value="id"
                          label="Moneda"
                          loading="loadingMonedas"
                        ></v-autocomplete>
                      </v-col>
                      <v-col class="caption">
                        <v-text-field
                          label="Abona con"
                          v-model="abonaCon"
                          prefix="$"
                        ></v-text-field>
                      </v-col>
                      <v-col class="caption">
                        <v-text-field
                          :label="
                            listMonedas.length > 0 &&
                            !listMonedas.find((m) => m.id == model.monedaId)
                              .predeterminada
                              ? 'Vuelto Moneda Local'
                              : 'Vuelto'
                          "
                          :disabled="true"
                          v-model="vuelto"
                          prefix="$"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                     <!-- <v-row>
                     <v-col class="caption">
                     
                       <v-textarea
                          v-model="comentario"
                          label="Comentario"
                          placeholder="Ingrese su comentario aquí"
                          hint="El comentario es opcional y sin límite de caracteres"
                          rows="2"
                        ></v-textarea>
                      </v-col>
                    </v-row> -->
                    <v-row
                      v-if="
                        $store.state.parametrosGenerales
                          .cajaPermiteMultiMoneda &&
                        cajaMultiMoneda &&
                        listMonedas.length > 0 &&
                        !listMonedas.find((m) => m.id == model.monedaId)
                          .predeterminada
                      "
                    >
                      <v-col
                        v-if="
                          listMonedas.find((m) => m.id == model.monedaId)
                            .cotizacion > 0
                        "
                      >
                        <v-chip color="info">
                          {{
                            listMonedas.find((m) => m.id == model.monedaId)
                              .cotizacionDescripcion
                          }}
                        </v-chip>
                      </v-col>
                      <v-col v-else>
                        <v-chip color="error">
                          {{
                            listMonedas.find((m) => m.id == model.monedaId)
                              .cotizacionDescripcion
                          }}
                        </v-chip>
                      </v-col>

                      <v-col
                        v-if="
                          listMonedas.length > 0 &&
                          !listMonedas.find((m) => m.id == model.monedaId)
                            .predeterminada
                        "
                      >
                        <v-chip color="green" dark>
                          Equivale a: {{ importeMonedaLocal | currency }}
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-row>
                <v-row
                  v-if="
                    formaPago == 'transferencia' &&
                    $store.state.parametrosGenerales
                      .cajaHabilitarCobroTransferencia
                  "
                >
                  <v-container fluid>
                    <v-row>
                      <v-col class="caption">
                        <v-text-field label="Banco"></v-text-field>
                      </v-col>
                      <v-col class="caption">
                        <v-text-field label="Nº Identificación"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="caption">
                        <v-text-field label="Comentarios"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-row>
                <v-row
                  v-if="
                    formaPago == 'cheque' &&
                    $store.state.parametrosGenerales.cajaHabilitarCobroCheque
                  "
                >
                  <v-container fluid>
                    <v-row>
                      <v-col class="caption">
                        <v-text-field label="Banco"></v-text-field>
                      </v-col>
                      <v-col class="caption">
                        <v-text-field label="Nº Cheque"></v-text-field>
                      </v-col>
                      <v-col class="caption">
                        <v-text-field label="Fecha" type="date"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="caption">
                        <v-text-field label="Comentarios"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-row>
                <v-row
                  v-if="
                    formaPago == 'tarjeta' &&
                    $store.state.parametrosGenerales.cajaHabilitarCobroTarjeta
                  "
                >
                  <v-container fluid>
                    <v-row>
                      <v-col class="caption">
                        <v-text-field label="Marca"></v-text-field>
                      </v-col>
                      <v-col class="caption">
                        <v-text-field label="Nº Cupón"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="caption">
                        <v-text-field label="Comentarios"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-row>
                <v-row
                  v-if="
                    formaPago == 'mercadoPago' &&
                    $store.state.parametrosGenerales
                      .cajaHabilitarCobroMercadoPago
                  "
                >
                  <v-container fluid>
                    <v-row>
                      <v-col class="caption">
                        <v-text-field
                          label="Abona con"
                          v-model="abonaCon"
                          prefix="$"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-row>
                <v-row
                  v-if="
                    formaPago == 'posnet' &&
                    $store.state.parametrosGenerales
                      .cajaHabilitarCobroMercadoPago
                  "
                >
                  <v-container fluid>
                    <v-row>
                      <v-col class="caption">
                        <v-text-field
                          label="Abona con"
                          v-model="abonaCon"
                          prefix="$"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-row>
                <v-row
                  v-if="
                    formaPago == 'cbu' &&
                    $store.state.parametrosGenerales
                      .cajaHabilitarCobroMercadoPago
                  "
                >
                  <v-container fluid>
                    <v-row>
                      <v-col class="caption">
                        <v-text-field
                          label="Abona con"
                          v-model="abonaCon"
                          prefix="$"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="caption">
                        <v-autocomplete
                          v-model="model.formatoEnvioId"
                          :items="formatosEnvio"
                          item-text="descripcion"
                          item-value="id"
                          label="Formato de envío:"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-row>
                <v-col cols="12">
                  <v-col v-if="requiereBancoAcreditacion == true">
                    <v-autocomplete
                      v-model="model.bancoAcreditacionId"
                      :items="bancosacreditacion"
                      item-text="descripcion"
                      item-value="id"
                      label="Banco Acreditacion"
                      placeholder="Seleccione un Banco de Acreditacion"
                    ></v-autocomplete>
                  </v-col>
                </v-col>
                 <!-- fecha proceso{{fechaProceso}}  -->

                 <v-row>
            </v-row>

              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
                     <v-col class="caption">
                     
                       <v-textarea
                          v-model="comentario"
                          label="Comentario"
                          placeholder="Ingrese su comentario aquí"
                          hint="El comentario es opcional y sin límite de caracteres"
                          rows="2"
                        ></v-textarea>
                      </v-col>
                    </v-row>
        
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          color="blue darken-1"
          text
          @click.stop="hideActiveTask"
          :disabled="saving"
          >Cancelar</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          color="green "
          dark
          @click.stop="save"
          :disabled="saving || corabranzaRealizada"
          >Confirmar</v-btn
        >
      </v-card-actions>
    </v-card>

    <app-loading :loading="saving"></app-loading>
  </v-container>
</template>

<script>
import Vue from 'vue';
import { http } from '@/axios';

import { Decimal } from 'decimal.js';

import { mapMutations } from 'vuex';

export default {
  data: () => ({
    editModeOn: false,
    loading: false,
    loadingMonedas: false,
    saving: false,
    corabranzaRealizada: false,
    formaPago: [],
    model: {
      monedaId: 1,
      cotizacion: 1,
      c: 0,
      bancoAcreditacionId: 1,
    },
    abonaCon: null,
    listMonedas: [],
    bancosacreditacion: [],
    comentario: '',
  }),
  props: {
    detalleCobranza: {
      type: Array,
      default: function () {
        return [];
      },
    },
    personaId: {
      type: String,
      required: false,
      default: null,
    },
    cajaId: {
      type: Number,
    },
    bancoAcreditacionId: {
      type: Number,
    },
    cajaMultiMoneda: { type: Boolean },
    requiereBancoAcreditacion: { type: Boolean, required: true },
    fechaCaja: {
      type: String,
    },
    fechaProceso: {
      type: String,
    },
    accionConfirmada: {
      type: Function,
    },
     formatoEnvioDebitoId: {
      type: Number,
      required: true
    },
      comentario: {
      type: String,
    },
  },
  computed: {
    totalAPagar: function () {
      if (!this.detalleCobranza || this.detalleCobranza.length == 0) return 0;

      var total = 0;
      for (let index = 0; index < this.detalleCobranza.length; index++) {
        total = new Decimal(total).plus(
          new Decimal(this.detalleCobranza[index].total)
        );
      }
      return total.toFixed(2);
    },
    vuelto: function () {
      if (!this.abonaCon) return null;

      return new Decimal(this.importeMonedaLocal)
        .minus(new Decimal(this.totalAPagar))
        .toFixed(2);
    },
    importeMonedaLocal: function () {
      if (this.listMonedas.length <= 1) return this.abonaCon;
      if (this.abonaCon == '') return 0;

      var moneda = this.listMonedas.find((m) => m.id == this.model.monedaId);
      if (!moneda.predeterminada)
        return new Decimal(this.abonaCon).times(moneda.cotizacion);

      return this.abonaCon;
    },
  },
  created() {
    this.abonaCon = this.totalAPagar;
    this.formaPago = 'efectivo';
    this.loadBancosAcreditacion();
    this.loadFormatosEnvio();
    if (this.cajaMultiMoneda) this.loadMonedas();
    console.log('Propiedad cajaId CONFIRMARCOBRANZA:', this.cajaId);
    //Pruebas Dylan
    this.model.formatoEnvioId = this.formatoEnvioDebitoId;      
   
    console.log('Propiedad formatoEnvioDebitoId CONFIRMARCOBRANZA:', this.formatoEnvioDebitoId);                   
 },

  watch: {
    'model.monedaId': function () {
      if (this.model.monedaId == null) return;

      if (this.listMonedas.length <= 1) {
        this.abonaCon = this.totalAPagar;
        this.model.cotizacion = 1;
      } else {
        var moneda = this.listMonedas.find((m) => m.id == this.model.monedaId);
        this.model.cotizacion = moneda.cotizacion;
        if (moneda.predeterminada) {
          this.abonaCon = this.totalAPagar;
        } else {
          this.abonaCon = new Decimal(this.totalAPagar)
            .dividedBy(moneda.cotizacion)
            .toFixed(2);
        }
      }
    },
  },
  methods: {
    ...mapMutations([
      'hideActiveTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    async save() {
      if (this.totalAPagar == 0) return;

      var params = {};
      params.personaId = this.personaId;
      params.cajaId = this.cajaId;
      params.cajaMultiMoneda = this.multiMoneda;
      params.requiereBancoAcreditacion = this.requiereBancoAcreditacion;
      params.bancoAcreditacionId = this.model.bancoAcreditacionId;
      params.fechaCaja = this.fechaCaja;
      params.fechaProceso = this.fechaProceso;
      params.importeTotal = this.totalAPagar;
      params.abonaCon = this.abonaCon;
      params.detalle = this.detalleCobranza;
      params.monedaId = this.model.monedaId;
      params.cotizacion = this.model.cotizacion;
      params.formaPago = this.formaPago;
      if (this.formaPago == 'cbu') params.origenId = this.model.formatoEnvioId;
      params.comentario = this.comentario;
      Vue.$log.debug(params);
      //return;

      try {
        this.saving = true;
        var res = await http.post(
          'cajas/altacobranza',
          JSON.stringify({ parametros: params })
        );
        this.corabranzaRealizada = true;

        this.alertSuccess('Se ha realizado la cobranza');
        this.accionConfirmada(res.list);
      } catch (error) {
        // Error
        this.alertError(error);
      } finally {
        this.saving = false;
      }
    },
    async loadBancosAcreditacion() {
      this.loading = true;
      try {
        var result = await http.get('bancosacreditacion');
        Vue.$log.debug('bancosacreditacion');

        this.bancosacreditacion = result.list;
        Vue.$log.debug(this.bancosacreditacion);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadMonedas() {
      this.listMonedas = [];
      this.loadingMonedas = true;
      try {
        var result = await http.get('monedas');
        this.listMonedas = result.list;
        this.model.monedaId = this.listMonedas.find(
          (m) => m.predeterminada == true
        ).id;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loadingMonedas = false;
    },
    async loadFormatosEnvio() {
      this.loading = true;
      try {
        var result = await http.get('archivosDebito/formatosenvio'); // traigo todos
        this.formatosEnvio = result.list;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
  },
};
</script>
